export default "__VITE_ASSET__DujxeWLD__"